import { useRef } from 'react';
import styles from './Radio.module.scss';

interface IProps {
  groupName?: string;
  label: string;
  isChecked: boolean;
  onSelect: () => void;
}

// TODO: disabled, error states not implemented yet
export const Radio = ({ groupName, label, isChecked, onSelect }: IProps) => {
  // random constant id
  const idRef = useRef('radio' + Math.trunc(Math.random() * 100000));

  return (
    <div className={styles.radio}>
      <input
        type="radio"
        id={idRef.current}
        name={groupName}
        checked={isChecked}
        className={styles.radioHiddenInput}
        onChange={onSelect}
      />
      <div className={styles.radioContainer}>
        <div className={styles.radioControl} />
        <label htmlFor={idRef.current} className={styles.radioLabel}>
          {label}
        </label>
      </div>
    </div>
  );
};
